import React, { FC, useEffect } from "react";
import "./UserAccountSettings.scss";
import { HOME } from "../../common/constants/routes.constants";
import UserSettingsForm from "../../components/UserSettingsForm/UserSettingsForm";

import { useWallet } from "@solana/wallet-adapter-react";
import { useNavigate } from "react-router";
import { Helmet } from "react-helmet-async";

const UserAccountSettings: FC = () => {
  const { publicKey } = useWallet();
  const navigate = useNavigate();

  useEffect(() => {
    if (!publicKey) {
      navigate(HOME);
    }
  }, [publicKey]);

  return (
    <div className="user-account-settings">
      <Helmet>
        <title> Unique | Account Settings</title>
      </Helmet>
      <div className="user-account-settings__content">
        <div className="user-account-settings__settings-tab">
          <h2>Account settings</h2>
          <UserSettingsForm />
        </div>
      </div>
    </div>
  );
};

export default UserAccountSettings;
